import React from "react";
import { Route, Redirect } from "react-router-dom";

const AppRoute = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  isLoggedIn,
  exact,
  ...rest
}) => (
  <Route
    exact
    {...rest}
    render={(props) => {
      // console.log("props>>>>>", isLoggedIn);
      // if (!isLoggedIn) <Redirect to="/login" />;
      // if (isAuthProtected && !localStorage.getItem("infoSalonsUser")) {
      //   return <Redirect to="/login" />;
      // }

      return (
        <Layout>
          <Component {...props} />
        </Layout>
      );
    }}
  />
);

export default AppRoute;
